import { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Radio } from 'antd';
import { ApplicationUIContext } from '../Provider/Provider';

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  width: 100%;

  > * {
    flex: 1;
    text-align: center;
  }
`;

const DrawerTabs = ({ options, value, onChange }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <StyledRadioGroup
      value={value}
      onChange={onChange}
      optionType="button"
      size={isMobile && 'large'}
      options={options}
    />
  );
};

DrawerTabs.propTypes = {
  options: PropTypes.array,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default DrawerTabs;
